import ManagerService from '@/api/ManagerService';

export const InitialAdminPath = () => {
  const managerJWT = ManagerService.getManagerJWTDecoded();

  /**
   * Manager has no business
   */
  if (
    managerJWT &&
    managerJWT.extraInfo &&
    managerJWT.extraInfo.requireBusiness
  ) {
    return '/manager';
  }

  return '/home';
};

export const InitialSuperAdminPath = '/admin/dashboard';
